<template>
  <div @click.self="() => onBlurHandler()" class="frisbuy-popup-with-slot">
    <div class="frisbuy-popup-with-slot__content-wrapper">
      <button class="frisbuy-close-button" @click="$emit('close')">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.35355 5.64645C6.15829 5.45118 5.84171 5.45118 5.64645 5.64645C5.45118 5.84171 5.45118 6.15829 5.64645 6.35355L11.2929 12L5.64645 17.6464C5.45118 17.8417 5.45118 18.1583 5.64645 18.3536C5.84171 18.5488 6.15829 18.5488 6.35355 18.3536L12 12.7071L17.6464 18.3536C17.8417 18.5488 18.1583 18.5488 18.3536 18.3536C18.5488 18.1583 18.5488 17.8417 18.3536 17.6464L12.7071 12L18.3536 6.35355C18.5488 6.15829 18.5488 5.84171 18.3536 5.64645C18.1583 5.45118 17.8417 5.45118 17.6464 5.64645L12 11.2929L6.35355 5.64645Z"
            fill="#858F9A"
          />
        </svg>
      </button>

      <slot></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "../mixins.scss";

* {
  margin: 0;
  padding: 0;
  text-decoration: none;
  list-style: none;

  box-sizing: border-box;
}

.frisbuy-popup-with-slot {
  display: flex;
  position: fixed;
  inset: 0;

  flex-direction: column;
  justify-content: center;

  width: 100dvw;
  height: 100dvh;

  background-color: rgba($color: #000000, $alpha: 0.8);

  overflow-x: auto;

  .frisbuy-close-button {
    position: absolute;
    inset: 24px 16px auto auto;

    width: fit-content;
    height: fit-content;

    background: transparent;
    outline: none;
    border: none;
    cursor: pointer;

    border-radius: 4px;

    z-index: 1;

    svg {
      display: block;

      width: 44px;
      height: 44px;
    }
  }

  .frisbuy-popup-with-slot__content-wrapper {
    position: relative;

    width: 100%;
    max-width: $size-l;
    overflow-y: auto;

    background-color: #ffffff;

    margin: 0 auto;
  }
}

@media screen and (orientation: portrait) and (max-width: #{$size-m}) {
  .frisbuy-popup-with-slot {
    .frisbuy-close-button {
      inset: 16px 16px auto auto;
    }
  }
}
</style>

<script>
export default {
  emits: ["blur", "close"],

  props: {
    customScrollElement: {
      type: String,
      required: false,
    },
  },

  data() {
    return {};
  },

  mounted() {
    this.lockWindowScroll();
  },

  beforeUnmount() {
    this.unlockWindowScroll();
  },

  methods: {
    onBlurHandler() {
      this.$emit("blur");
    },

    lockWindowScroll() {
      const scrollElement = this.customScrollElement || "body";
      document.querySelector(scrollElement).style.overflow = "hidden";
    },

    unlockWindowScroll() {
      const scrollElement = this.customScrollElement || "body";
      document.querySelector(scrollElement).style.overflow = "";
    },
  },
};
</script>
